// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"Logo_titleWrapper__J_vPh","logo":"Logo_logo__Ov_7Y","title":"Logo_title__mPqCq"};